import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSubdomain, detectWebApp } from '@/utils';
import { fetchSiteMetadataActions } from '@/redux/actions/site';
import { fetchApiDocsActions, fetchApiGroupsActions } from '@/redux/actions/api-docs';
import { fetchDocsOverviewActions } from '@/redux/actions/service-directory';
import { fetchEntityActions } from '@/redux/actions';
import { RootState } from '@/redux/reducers';
// import LoadingIndicator from '@/components/LoadingIndicator';
import NotFound from '@/pages/NotFound/404';
import Unauthorized from '@/pages/Unauthorized';
import HelmetHead from '@/components/HelmetHead/HelmetHead';
import env from '@/env';

interface ConfigureLayoutProps {
  layout: any;
  path: string;
  children: React.ReactNode;
}

const useConfigLayout = () => {
  const apiDocs = useSelector((state: RootState) => state.apiDocs);
  const organisation = useSelector((state: RootState) => state.site.organisation);
  const authUser = useSelector((state: RootState) => state.authUser.data);
  const { userInfo } = useSelector((state: RootState) => state.membership);

  return { apiDocs, organisation, authUser, userInfo };
};

const subdomain = getSubdomain();
const shouldFetchApiDocs = subdomain && subdomain !== 'www';

const ConfigureLayout = (props: ConfigureLayoutProps) => {
  const { layout: LayoutComponent, path, children } = props;
  const errors: any = useSelector((state: RootState) => state.errors);

  const dispatch = useDispatch();
  const webApp = detectWebApp[env.siteId as keyof typeof detectWebApp];
  const { organisation, authUser } = useConfigLayout();
  // const isFetchingEntity = useSelector((state: RootState) => state.loading.FETCH_ENTITY);

  useEffect(() => {
    if (shouldFetchApiDocs) {
      dispatch(fetchSiteMetadataActions.request(subdomain ?? ''));
      dispatch(fetchEntityActions.request(subdomain ?? ''));
    }
  }, [dispatch]);

  useEffect(() => {
    if (organisation) {
      if (window.location.pathname.search('my-apis') === -1) {
        dispatch(fetchApiDocsActions.request(organisation.id));
      }

      dispatch(fetchApiGroupsActions.request(organisation.id));
      dispatch(fetchDocsOverviewActions.request(organisation.id));
    }
  }, [dispatch, organisation, authUser]);

  // if (shouldFetchApiDocs && !errors.FETCH_ENTITY && isFetchingEntity !== false) {
  //   return <LoadingIndicator />;
  // }

  return (
    <LayoutComponent path={path}>
      <HelmetHead title={webApp.siteName} description={webApp.siteName} />
      {errors.FETCH_ENTITY ? (
        <>
          {errors.FETCH_ENTITY?.status === 404 && <NotFound />}
          {errors.FETCH_ENTITY?.status === 403 && <Unauthorized />}
        </>
      ) : (
        children
      )}
    </LayoutComponent>
  );
};

export { ConfigureLayout, useConfigLayout };
